import { FunctionComponent } from "react";

import ThemesAccordion, { IThemesAccordionProps } from "./themesAccordion";

import ReferentialProvider, { ReferentialProps } from "context/referentialContext";

const Referential: FunctionComponent<IThemesAccordionProps & ReferentialProps> = ({
  brandSourcesByCriteriumId,
  additionalLeadingItems,
  additionalTrailingItems,
  ...props
}) => {
  return (
    <ReferentialProvider {...props}>
      <ThemesAccordion
        brandSourcesByCriteriumId={brandSourcesByCriteriumId}
        additionalLeadingItems={additionalLeadingItems}
        additionalTrailingItems={additionalTrailingItems}
      />
    </ReferentialProvider>
  );
};

export default Referential;
